export default "__VITE_ASSET__Cketfcob__"